import React from "react";
import { ListItem, ListItemButton, ListItemIcon } from "@mui/material";
import { LISTITEM_ICON_WIDTH, StyledListItemText } from "./MainMenuWithoutLink";
import { useLocation } from "react-router-dom";

type MainMenuWithLinkProps = {
  handleMainMenuWithLinkOnClick: () => void;
  children: JSX.Element;
  menuName: string;
  pathName: string;
};

const MainMenuWithLink = ({
  handleMainMenuWithLinkOnClick,
  children,
  menuName,
  pathName,
}: MainMenuWithLinkProps) => {
  const location = useLocation();
  return (
    <ListItem
      disablePadding
      onClick={handleMainMenuWithLinkOnClick}
      key={menuName}
      sx={{ color: "white", "&.active": { backgroundColor: "#4eca0c" } }}
      className={location.pathname === pathName ? "active" : ""}
    >
      <ListItemButton sx={{ pt: "4px", pb: "4px" }}>
        <ListItemIcon sx={{ color: "inherit", minWidth: LISTITEM_ICON_WIDTH }}>
          {children}
        </ListItemIcon>
        <StyledListItemText primary={menuName} />
      </ListItemButton>
    </ListItem>
  );
};

export default MainMenuWithLink;
